import { AggregateFunctions, ColumnDataType, ColumnSortDirection, CompareOperators, } from './column';
const defaultOriginDateFormat = 'YYYY-MM-DD';
const defaultOriginDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
const defaultDisplayDateFormat = 'YYYY-MM-DD';
const defaultDisplayDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
const defaultComputedCsvValueGetter = (_column, _row, _isHeader = false) => '';
const getSortDirectionFromOptions = (options) => (options.sortable && options.sortDirection) || ColumnSortDirection.None;
const getSortOrder = (sortDirection, options) => (sortDirection !== ColumnSortDirection.None && options.sortOrder) || -1;
const checkUndefined = (value, defaultValue = true) => value === undefined ? defaultValue : value;
const getSortDirection = (sortDirection) => {
    if (sortDirection === ColumnSortDirection.None)
        return ColumnSortDirection.Ascending;
    return sortDirection === ColumnSortDirection.Ascending
        ? ColumnSortDirection.Descending
        : ColumnSortDirection.None;
};
export const sortColumnArray = (columnName, columns, multiSort) => {
    const column = columns.find((c) => c.name === columnName);
    if (!column) {
        //@ts-ignore
        return undefined;
    }
    column.sortDirection = getSortDirection(column.sortDirection);
    column.sortOrder =
        column.sortDirection === ColumnSortDirection.None ? -1 : Number.MAX_VALUE;
    if (!multiSort) {
        columns
            .filter((col) => col.name !== columnName)
            .forEach((c) => {
            c.sortOrder = -1;
            c.sortDirection = ColumnSortDirection.None;
        });
    }
    columns
        .filter((col) => col.sortOrder > 0)
        .sort((a, b) => {
        if (a.sortOrder === b.sortOrder)
            return 0;
        return a.sortOrder > b.sortOrder ? 1 : -1;
    })
        .forEach((col, i) => {
        col.sortOrder = i + 1;
    });
    return columns;
};
export const columnHasFilter = (column) => (!!column.filterText || !!column.filterArgument) &&
    column.filterOperator !== CompareOperators.None;
export const createColumn = (name, options) => {
    const temp = options || {};
    const sortDirection = getSortDirectionFromOptions(temp);
    return {
        aggregate: temp.aggregate || AggregateFunctions.None,
        dataType: temp.dataType || ColumnDataType.String,
        dateDisplayFormat: temp.dateDisplayFormat || defaultDisplayDateFormat,
        dateOriginFormat: temp.dateOriginFormat || defaultOriginDateFormat,
        dateTimeDisplayFormat: temp.dateTimeDisplayFormat || defaultDisplayDateTimeFormat,
        dateTimeOriginFormat: temp.dateTimeOriginFormat || defaultOriginDateTimeFormat,
        getComputedStringValue: temp.getComputedStringValue || defaultComputedCsvValueGetter,
        isKey: !!temp.isKey,
        isComputed: checkUndefined(temp.isComputed, false),
        label: temp.label || (name || '').replace(/([a-z])([A-Z])/g, '$1 $2'),
        name,
        searchable: !!temp.searchable,
        sortDirection,
        sortOrder: getSortOrder(sortDirection, temp),
        sortable: !!temp.sortable,
        visible: checkUndefined(temp.visible),
        //@ts-ignore
        filterArgument: temp.filterArgument,
        //@ts-ignore
        filterOperator: temp.filterOperator,
        //@ts-ignore
        filterText: temp.filterText,
        filterable: checkUndefined(temp.filterable, false),
        exportable: checkUndefined(temp.exportable),
    };
};
export const isDateColum = (column) => column.dataType === ColumnDataType.Date ||
    column.dataType === ColumnDataType.DateTime ||
    column.dataType === ColumnDataType.DateTimeUtc;
